export const getSalesLeaguePageCount = (rowCount: number, rowsPerPage: number) =>
  Math.max(1, Math.ceil(rowCount / rowsPerPage));

/** Row-shape agnostic: both boards paginate, over different row types. */
export const paginateSalesLeagueRows = <TRow>(rows: TRow[], page: number, rowsPerPage: number) =>
  rows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
